module.exports = __webpack_public_path__ + "static/contact-us-hero-image@2x-3be2b24f0c8f25d42f5a3039e1cf9ecd.jpg";